import BaseTable from "../BaseTable";
import BackgroundModals from "@/Modals/ContentManagement/Backgrounds/Modal";
import Columns from "./Columns"; 
import { backgroundsApi } from "@/apis/apis";

export default function BackgroundsPage() {
  return (
    <BaseTable
      label="Background"
      apiURL={backgroundsApi}
      columns={Columns()} 
      ModalComponent={BackgroundModals}
      importData={null}
      enableSortData={true}
      confirmationModalTitleKey="title"
    />
  );
}
